// Fachada de numeración de paradas para la vista. Cuando la ruta viene filtrada por empresa
// (`filtered_by_company_id`), la API solo manda las paradas de esa empresa pero con su
// `position` en la ruta completa (3 y 4, por ejemplo): mostrarla le diría a la empresa cuántas
// paradas de otras hay en la ruta. Se ordenan por la posición real y se numeran de 1 en
// adelante. Sin filtro la posición real es la que se muestra. `position` no se modifica; la
// vista pinta `display_number`.
export function withDisplayStopNumbers(route) {
  if (!route || !route.stops) {
    return route;
  }

  const ordered = [...route.stops].sort((a, b) => a.position - b.position);
  const scopedToCompany = Boolean(route.filtered_by_company_id);

  return {
    ...route,
    stops: ordered.map((stop, index) => ({
      ...stop,
      display_number: scopedToCompany ? index + 1 : stop.position,
    })),
  };
}
